/* Nyluno extras: deferred muted video loops, and keeping chat widgets clear of the mobile sticky bar. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* Loops: the file is requested only when the clip nears the viewport, phones get the
     smaller rendition, playback pauses off-screen, and a visible button pauses/plays. */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else pause(e.target); });
  }, { rootMargin: '200px 0px' }) : null;
  function pick(w) {
    var small = window.matchMedia('(max-width: 749px)').matches;
    var v = w.querySelector('video'), hls = w.getAttribute('data-src-h');
    if (small && hls && v && v.canPlayType('application/vnd.apple.mpegurl')) return hls;
    return (small && w.getAttribute('data-src-m')) || w.getAttribute('data-src-d') || w.getAttribute('data-src-m');
  }
  function load(w) {
    var v = w.querySelector('video'); if (!v) return null;
    if (!v.getAttribute('src')) { var u = pick(w); if (u) { v.setAttribute('src', u); v.load(); } }
    return v;
  }
  function play(w) {
    if (w._user === 'paused' || (reduce && w._user !== 'playing')) return;
    var v = load(w); if (!v) return; v.muted = true;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function pause(w) { var v = w.querySelector('video'); if (v && !v.paused) v.pause(); }
  function initLoops(scope) {
    $$('[data-nyl-loop]', scope).forEach(function (w) {
      if (w._nylx) return; w._nylx = 1;
      var v = w.querySelector('video'), t = w.querySelector('[data-nyl-loop-toggle]'); if (!v) return;
      function sync() {
        if (!t) return; var paused = v.paused;
        t.setAttribute('aria-label', paused ? (t.getAttribute('data-play') || 'Play video') : (t.getAttribute('data-pause') || 'Pause video'));
        t.classList.toggle('is-paused', paused);
      }
      v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
      if (t) t.addEventListener('click', function () {
        if (v.paused) { w._user = 'playing'; load(w); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { w._user = 'paused'; v.pause(); }
      });
      if (io) io.observe(w); else play(w);
    });
  }

  /* Sticky bar: mirror its visibility on <body> so chat bubbles can move above it. */
  function initStickyWatch() {
    $$('[data-nyl-sticky]').forEach(function (bar) {
      if (bar._nylx) return; bar._nylx = 1;
      function upd() {
        var on = bar.classList.contains('is-visible');
        d.body.classList.toggle('nyl-sticky-on', on);
        if (on) d.documentElement.style.setProperty('--nyl-sticky-h', bar.offsetHeight + 'px');
      }
      new MutationObserver(upd).observe(bar, { attributes: true, attributeFilter: ['class'] });
      upd();
    });
  }

  function boot(scope) { initLoops(scope); initStickyWatch(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(d); }); else boot(d);
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
